import { inject, Injectable } from '@angular/core';
import { ApiResponseModel, ApiService } from '@solcre-org/core';
import { map, Observable } from 'rxjs';
import { environment } from '../../../environments/environment.local';
import { CountryHolidaySyncResult } from '../models/country-holiday.model';

@Injectable({
  providedIn: 'root',
})
export class CountryHolidayService {
  private apiService: ApiService = inject(ApiService);

  public synchronize(country: string, year: number): Observable<CountryHolidaySyncResult> {
    return this.apiService
      .createObj(environment.API.COUNTRY_HOLIDAYS_SYNCHRONIZE_URI, { country, year })
      .pipe(map((response: ApiResponseModel) => response.data as CountryHolidaySyncResult));
  }
}
